import { createContext, useContext } from "react";
import { FilterState } from "./state-models";

export type FilterStateControllerTiming = "immediate" | "deferred";
export type FilterStateControllerTarget = "global" | "branch";

export interface FilterStateControllerRequestOptions {
    source: string;
}

export interface FilterStateControllerContextValue {
    timing: FilterStateControllerTiming;
    target: FilterStateControllerTarget;
    hasPendingChanges: boolean;
    pendingState: FilterState | null;
    effectiveState: FilterState;
    requestChange: (recipe: (state: FilterState) => FilterState, options: FilterStateControllerRequestOptions) => void;
    apply: () => void;
    clearPending: () => void;
}

export const FilterStateControllerContext = createContext<FilterStateControllerContextValue | null>(null);

export function useFilterStateController(): FilterStateControllerContextValue | null {
    return useContext(FilterStateControllerContext);
}
